import { defineStore } from 'pinia';
import { api, HttpError } from '@/api/client';
import type { Identity } from '@/api/types';

export const useUserStore = defineStore('user', {
    state: () => ({
        identity: null as Identity | null,
        loaded: false,
        loading: false,
    }),
    actions: {
        async load() {
            if (this.loading) return;
            this.loading = true;
            try {
                this.identity = await api<Identity>('/api/me');
            } catch (e) {
                if (e instanceof HttpError && e.status === 401) {
                    this.identity = null;
                } else {
                    throw e;
                }
            } finally {
                this.loaded = true;
                this.loading = false;
            }
        },
        async logout() {
            const res = await fetch('/auth/logout', { method: 'POST', credentials: 'include' });
            this.identity = null;
            if (res.ok) {
                const body = await res.json().catch(() => ({}));
                if (body.logoutUrl) window.location.href = body.logoutUrl;
                else window.location.href = '/login';
            } else {
                window.location.href = '/login';
            }
        },
    },
});
